import { render, staticRenderFns } from "./InspectionShipmentList_backlogList.vue?vue&type=template&id=29472796&scoped=true"
import script from "./InspectionShipmentList_backlogList.vue?vue&type=script&lang=js"
export * from "./InspectionShipmentList_backlogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29472796",
  null
  
)

export default component.exports